// Dual-pipe analytics helper: pushes events to both Meta Pixel
// (window.fbq) and Plausible (window.plausible) if loaded.
// Safely no-ops if either script hasn't loaded yet.
// Both pipes receive the params object so Plausible custom dimensions work too.
export function trackEvent(name: string, params?: Record<string, any>): void {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (typeof w.fbq === 'function') {
    w.fbq('track', name, params);
  }
  if (typeof w.plausible === 'function') {
    w.plausible(name, params ? { props: params } : undefined);
  }
}
